import React from 'react'

export interface InterpolateElementProps {
  text: string
  parameters: { [key: string]: React.ReactNode }
}

const InterpolateElement = ({ text, parameters }: InterpolateElementProps) => {
  const strings: { [key: string]: string }[] = []
  text.replace(/\{([^}]+)\}|[^{}]+/g, (match: string, val: string): string => {
    if (val) strings.push({ replace: val })
    else strings.push({ str: match })
    return '' // To resolve ts-lint error
  })

  return (
    <>
      {strings.map((node, index) => {
        let el = null
        if (node.str) el = node.str
        else el = parameters[node.replace] || node.replace
        return <React.Fragment key={`${text}-${index}`}>{el}</React.Fragment>
      })}
    </>
  )
}

export default InterpolateElement
